import {
    Module,
    VuexModule,
    getModule,
} from 'vuex-module-decorators';
import { DocumentationLinks, DocumentationState } from '~/interfaces/documentation.interface';
import { ConfigModule } from '~/store/modules/config';
import store from '~common-store';

@Module({ dynamic: true, store, name: 'documentation', namespaced: true })
class Documentation extends VuexModule implements DocumentationState {
    links: DocumentationLinks = {
        netatmo: {
            user: [
                {
                    text: 'List of Product Information You Need to Know (Based on Product MAC Address)',
                    link: 'https://netatmo.atlassian.net/wiki/spaces/NSKB/pages/2366013578/List+of+Product+Information+You+Need+to+Know+Based+on+Product+MAC+Address',
                },
                {
                    text: 'Admin Support Bible',
                    link: 'https://netatmo.atlassian.net/wiki/x/5IUltQ',
                },
            ],
            moderator: [
                {
                    text: 'Presentation of the new rights',
                    link: 'https://grpleg-my.sharepoint.com/:p:/g/personal/romain_le-scouarnec_legrand_com/EbcnoeXI1SZIqOgjG1FIjucB7cawesRuAQA7hGPB8SlRFg?e=BGNw0l&CID=7d007b9b-ecea-15fc-204a-0a3318603769',
                },
                {
                    text: 'User guide new rights',
                    link: 'https://netatmo.atlassian.net/wiki/spaces/NPLF/pages/3951034369/ARM+V1+-+User+Guide',
                },
                {
                    text: 'Moderator guide',
                    link: 'https://netatmo.atlassian.net/wiki/spaces/NPLF/pages/3998417192/USER+GUIDE+Admin+moderator',
                },
                {
                    text: 'List Scope & Rights',
                    link: 'https://grpleg-my.sharepoint.com/:x:/g/personal/romain_le-scouarnec_legrand_com/EZA2JQwCkSlMkZ3OS3_d7YgBhRzqO3KuBqPRvx_uranUgA?e=npbCry',
                },
                {
                    text: 'Jira guide',
                    link: 'https://netatmo.atlassian.net/wiki/spaces/NPLF/pages/3998253147/USER+GUIDE+ADMIN+-+Jira+Rights+Demand+Management#Admin-Group-creation-request-process',
                },
            ],
        },
    };

    get environmentPrefix() {
        return ConfigModule.environmentPrefix;
    }

    get environmentLinks() {
        return this.links[this.environmentPrefix] || [];
    }
}

export const DocumentationModule = getModule(Documentation);
